<template>
  <div>
    <!--  
      <pre> {{ arrEdu }} </pre>
      <pre>{{ educationItems }}</pre>
    -->

    <a-row class="mt-20">
      <!-- add new form -->
      <a-col :span="14" :offset="3">
        <a-form-item
          label="Education (s)"
          :label-col="{ span: 8 }"
          :wrapper-col="{ span: 16 }"
          extra=""
        >
          <a-button type="dashed" block @click="addItemEducation">
            + Add Education
          </a-button>
        </a-form-item>
      </a-col>
    </a-row>

    <a-row>
      <a-col :span="20" :offset="2">
        <!-- list form  -->
        <a-form :layout="'horizontal'">
          <a-list
            class="demo-loadmore-list"
            item-layout="horizontal"
            :loading="loading"
            :data-source="educationItems.slice().reverse()"
          >
            <a-list-item slot="renderItem" slot-scope="item, index">
              <a-list-item-meta>
                <p slot="title" class="mt-0 mb-0">
                  <!-- <pre>{{ item }}</pre> -->
                </p>
                <div slot="description">
                  <a-row >
                    <a-col class="text-center" :span="20">
                      <a-row>
                        <a-col :span="5">
                          <h6 class="mt-5 mb-0">Name of University</h6>
                        </a-col>
                        <a-col :span="12">
                          <a-input
                            v-model:value="item.university_name"
                            type="text"
                            placeholder=""
                          />
                        </a-col>
                      </a-row>
                      <a-row class="mt-10">
                        <a-col :span="5">
                          <h6 class="mt-5 mb-0">Major</h6>
                        </a-col>
                        <a-col :span="12">
                          <a-input
                            v-model:value="item.major"
                            type="text"
                            placeholder=""
                          />
                        </a-col>
                      </a-row>
                      <a-row class="mt-10">
                        <a-col :span="5">
                          <h6 class="mt-5 mb-0">Degree</h6>
                        </a-col>
                        <a-col :span="12">
                          <a-select
                            show-search
                            placeholder="select..."
                            option-filter-prop="children"
                            v-model:value="item.type_graduate"
                          >
                            <a-select-option
                              v-for="(item, index) in optionType"
                              :key="index"
                              :value="item.value"
                            >
                              {{ item.text }}
                            </a-select-option>
                          </a-select>
                        </a-col>
                      </a-row>

                      <a-row class="mt-10">
                        <a-col :span="5">
                          <h6 class="mt-5 mb-0">Country</h6>
                        </a-col>
                        <a-col :span="12">
                          <a-select
                            show-search
                            placeholder="select..."
                            option-filter-prop="children"
                            v-model:value="item.country"
                          >
                            <a-select-option
                              v-for="(item, index) in optionCountry"
                              :key="index"
                              :value="item.value"
                            >
                              {{ item.text }}
                            </a-select-option>
                          </a-select>
                        </a-col>
                      </a-row>
                          
                      <!-- <a-row class="mt-10">
                        <a-col :span="5">
                          <h6 class="mt-5 mb-0">Start</h6>
                        </a-col>
                        <a-col class="text-left" :span="12">
                          <a-date-picker v-model="item.start_education" />
                        </a-col>
                      </a-row>
                      <a-row class="mt-10">
                        <a-col :span="5">
                          <h6 class="mt-5 mb-0">End</h6>
                        </a-col>
                        <a-col class="text-left" :span="12">
                          <a-date-picker v-model="item.end_education" />
                        </a-col>
                      </a-row> -->
                    </a-col>
                    <a-col :span="2">
                      <a-popconfirm
                        placement="topLeft"
                        ok-text="Yes"
                        cancel-text="No"
                        @confirm="removeItemEducation(index, item)"
                      >
                        <template slot="title">
                          <p class="mt-0 mb-0">Confirm Delete</p>
                          <p>Education {{ item.university_name }}</p>
                        </template>
                        <a-button type="link" class="text-center">
                          <a-icon
                            style="font-size: 20px; color: red"
                            type="delete"
                          />
                        </a-button>
                      </a-popconfirm>
                    </a-col>
                  </a-row>
                </div>
              </a-list-item-meta>
            </a-list-item>
          </a-list>
        </a-form>
      </a-col>
    </a-row>

    <!-- btn action -->
    <a-row class="mt-20">
      <a-col :span="10" :offset="5">
        <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
          <a-button
            :disabled="btnSubmitLoad"
            type="primary"
            class="mr-10"
            @click="onSubmitEducation"
          >
            <a-spin v-if="btnSubmitLoad" class="mr-10" /> Submit
          </a-button>
          <a-button type="danger" @click="backTomain"> Back </a-button>
        </a-form-item>
      </a-col>
    </a-row>
  </div>
</template>

<script>
const form = {
  id: "",
  university_name: "",
  start_education: "",
  end_education: "",
  country: "",
  type_graduate: "",
  major: "",
};
export default {
  props: {
    dataProfile: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formEdu: Object.assign({}, form),
      arrEdu: [],
      educationItems: [],
      loading: false,
      // option form
      optionMajor: [],
      optionType: [],
      optionCountry:[],
      btnSubmitLoad: false,
    };
  },
  async mounted() {
    this.getDataOption();
  },
  methods: {
    backTomain(){
      this.$router
        .push({
          path: "/alumni/",
        })
        .catch((err) => {});
    },
    setDefaultEducation() {
      if (this.dataProfile[0].education_detail.length !== 0) {
        this.arrEdu = this.dataProfile[0].alumin_education;
        this.educationItems = this.dataProfile[0].education_detail;
      }
    },
    async getDataOption() {
      this.loading = true
      const fetchMajor = await this.$http.get(`/student_affair/major/`);
      const fetchType = await this.$http.get(
        `/student_affair/education-graduate/`
      );
      const fetchCountry = await this.$http.get(
        `/student_affair/country-of-citizenship/`
      );
      Promise.all([fetchMajor, fetchType,fetchCountry])
        .then((response) => {
          return Promise.all(response.map((r) => r.data));
        })
        .then(([listA, listB, listC]) => {
          this.optionMajor = listA.map((item) => {
            return {
              id: item.id,
              text: `${item.name_eng} ${item.name_thai}`,
              value: item.id,
            };
          });
          this.optionType = listB.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
          this.optionCountry = listC.map((item) => {
            return {
              id: item.id,
              text: item.name_eng,
              value: item.id,
            };
          });
        })
        .catch((error) => {
          this.$emit("errorNotification", {
            errorMsg: error.response.status,
            urlPath: `fail call option list`,
          });
        });
      this.setDefaultEducation();
      this.loading = false
    },
    addItemEducation() {
      this.educationItems.push(this.formEdu);
    },
    async removeItemEducation(index, dataObj) {
      // //console.log(dataObj.id);
      if (dataObj.id === "") {
        const indexRemoveHtml = this.educationItems.findIndex(
          (item) => item.id === ""
        );
        this.educationItems.splice(indexRemoveHtml, 1);
      } else {
        try {
          const res = await this.$http.delete(
            `/student_affair/alumni-education/${dataObj.id}/`
          );
          if (res.status === 204) {
            var jsonUpdate = {};
            const indexDelPatch = this.arrEdu.findIndex(
              (item) => item === dataObj.id
            );
            this.arrEdu.splice(indexDelPatch, 1);
            const indexDel = this.educationItems.findIndex(
              (itemDel) => itemDel.id === dataObj.id
            );
            this.educationItems.splice(indexDel, 1);
            // create json
            jsonUpdate["alumin_education"] = this.arrEdu;
            this.updateMainProfile(jsonUpdate);
          } else {
            throw { res };
          }
        } catch (error) {
          this.$emit("errorNotification", {
            errorMsg: error.response.status,
            urlPath: `/student_affair/alumni-education/${dataObj.id}/`,
          });
        }
      }
    },
    async onSubmitEducation() {
      for (
        let listForm = 0;
        listForm < this.educationItems.length;
        listForm++
      ) {
        var jsonBodyEdu = {};
        const eduList = this.educationItems[listForm];
        const keys = Object.keys(eduList);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          // //console.log(key, eduList[key] )
          jsonBodyEdu[key] =
            key === "start_education" || key === "end_education"
              ? !["", null, "null"].includes(eduList[key])
                ? this.moment(eduList[key]).format("YYYY-MM-DD")
                : this.moment().format("YYYY-MM-DD")
              : eduList[key];
        }
        if (jsonBodyEdu.id !== "") {
          // patch
          this.updateEducation(jsonBodyEdu);
        } else {
          // post
          this.addNewEducation(jsonBodyEdu);
        }
      }
    },
    updateMainProfile(dataJson) {
      return new Promise((resolve) => {
        this.$http
          .patch(
            "/student_affair/alumni-profile/" + this.dataProfile[0].id + "/",
            dataJson
          )
          .then((response) => {
            if (response.status) {
              this.$emit("updateObjMainProfile", { data: response.data });
              this.setDefaultEducation();
              this.$emit("successNotification", {
                msg: "Success",
                des: `profile update`,
              });
              this.formEdu = Object.assign({}, form);
              resolve(true);
            }
          })
          .catch((error) => {
            // //console.log(error);
            resolve(false);
          });
      });
    },
    async addNewEducation(jsonData) {
      var jsonBody = {};
      try {
        const response = await this.$http.post(
          "/student_affair/alumni-education/",
          jsonData
        );
        if (response.status === 201) {
          this.btnSubmitLoad = true;
          this.arrEdu.push(response.data.id);
          jsonBody["alumin_education"] = this.arrEdu;
          this.updateMainProfile(jsonBody);
          this.btnSubmitLoad = false;
        } else {
          throw { response };
        }
      } catch (error) {}
    },
    updateEducation(jsonData) {
      this.btnSubmitLoad = true;
      return new Promise((resolve) => {
        this.$http
          .patch(
            "/student_affair/alumni-education/" + jsonData.id + "/",
            jsonData
          )
          .then((response) => {
            if (response.status) {
              this.btnSubmitLoad = false;
              resolve(true);
            }
          })
          .catch((error) => {
            // //console.log(error);
            resolve(false);
          });
      });
    },
  },
};
</script>
